import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import Image from "next/image";
import { useState, useCallback } from "react";
import LightBox from "@/components/LightBox";
import styles from "@/styles/Watch.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var IconZoomIn = function IconZoomIn(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      stroke: "#646464",
      strokeWidth: ".125",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "m23.838 22.525-5.884-5.885a10.101 10.101 0 0 0 2.344-6.479c0-5.596-4.553-10.149-10.15-10.149C4.554.012 0 4.565 0 10.162c0 5.595 4.553 10.147 10.149 10.147 2.46 0 4.72-.88 6.479-2.343l5.885 5.884a.938.938 0 1 0 1.326-1.326zM1.875 10.16c0-4.562 3.712-8.274 8.274-8.274 4.562 0 8.274 3.712 8.274 8.274 0 4.562-3.712 8.274-8.274 8.274-4.562 0-8.274-3.712-8.274-8.274z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      stroke: "#646464",
      strokeWidth: ".125",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M14.754 9.223h-3.668V5.555a.937.937 0 1 0-1.875 0v3.668H5.543a.938.938 0 0 0 0 1.875h3.668v3.668a.937.937 0 1 0 1.875 0v-3.668h3.668a.938.938 0 0 0 0-1.875z"
    })]
  }));
};

IconZoomIn.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
export default function WatchThumbnail(_ref) {
  var src = _ref.src,
      alt = _ref.alt;

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var toggle = useCallback(function () {
    setShow(function (show) {
      return !show;
    });
  }, []);
  if (!src) return null;
  var images = [src];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.watchThumbnail,
      onClick: toggle,
      children: [/*#__PURE__*/_jsx(Image, {
        src: src,
        alt: alt,
        layout: "fill",
        objectFit: "contain"
      }), /*#__PURE__*/_jsx("span", {
        className: styles.zoomIcon,
        children: /*#__PURE__*/_jsx(IconZoomIn, {})
      })]
    }), /*#__PURE__*/_jsx(LightBox, {
      show: show,
      images: images,
      onClose: toggle
    })]
  });
}